import { EntityScope } from '../../../../shared/utils/enums';
import { FC, ReactElement } from 'react';
import { Modal } from 'react-bootstrap';
import { ExerciseCategoryDto } from '../../../../shared/dtos/exerciseCategory.dto';
import ExerciseCategoryForm from './ExerciseCategoryForm';
import i18next from 'i18next';
import AppModal from '../app-modal/AppModal';

type ExerciseCategoryModalProps = {
  show: boolean;
  entityScope: EntityScope;
  exerciseCategory?: ExerciseCategoryDto;
  onClose: () => void;
  onSave: () => void;
}

const ExerciseCategoryModal: FC<ExerciseCategoryModalProps> = ({
  show,
  entityScope,
  exerciseCategory,
  onClose,
  onSave
}: ExerciseCategoryModalProps): ReactElement => {

  return (
    <AppModal show={show} onHide={onClose} backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title>
          {i18next.t(exerciseCategory ? 'exerciseCategoryModal.updateCategory' : 'exerciseCategoryModal.createCategory')}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <ExerciseCategoryForm
          initialData={exerciseCategory}
          entityScope={entityScope}
          onClose={onClose}
          onSubmit={() => {
            onSave();
            onClose();
          }}
        />
      </Modal.Body>
    </AppModal>
  );
};

export default ExerciseCategoryModal;
